import { get, some, first } from 'mori';

export default function getSelectedForVector(vec, selectedValue) {
  const foundValue = some((item) => (get(item, 'value') === selectedValue ? item : false), vec);

  return foundValue || first(vec);
}
